import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { apiService } from '../../../../../utils/api';
import { useSelector } from 'react-redux';
import ActionList from '../../../../../components/elements/ActionList';

const TemplateModal = ({
  visible,
  title = 'Šablony',
  onSubmit,
  onClose,
  classificationId,
}: {
  visible?: any;
  title?: any;
  onSubmit?: any;
  onClose?: any;
  classificationId?: any;
}) => {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const { modelId } = useSelector((state) => state.contract);

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const res = await apiService.get('/api/v1/instance-type-template/left-panel/', {
          params: {
            model: modelId,
            classification: classificationId,
          },
        });

        setTemplates(res.data?.results);
      } catch {
        //
      }
    };

    fetchTemplate();
  }, []);

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {!templates?.length ? (
            <div className="flex justify-center items-center">Žádné položky k dispozici.</div>
          ) : (
            <ActionList data={templates ?? []} selected={selected} onSelect={setSelected} />
          )}
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="typemark-template-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="typemark-template-modal-submit-btn"
            onClick={() => onSubmit(selected.id)}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TemplateModal;
